import React, { useState, useEffect } from 'react';
import * as Utils from '../../common/utils';
import * as REQUEST from "../../common/request";
import './index.less';

const PageModel = props => {
    const [url, setUrl] = useState('');
    const [list, setList] = useState([]);
    const getList = async (selectedId) => {
        const result = await REQUEST.get({
            url: '/zhujiajiao/v2/video/list',
            data: { type: selectedId }
        });
        if (!result) return;
        setList(result.data);
    };

    const getbanner = async () => {
        const result = await REQUEST.get({
            url: '/zhujiajiao/v2/file/get',
            data: { id: 5 }
        });
        if (!result) return;
        setUrl(result.data.link);
    };

    useEffect(() => {
        getList();
        getbanner();
        Utils.setPageTitle('精彩视频');
        return () => false;
    }, [123]);


    return (
        <section className="h5video-container" style={{ minHeight: window.innerHeight }}>
            <div className='h5video-top-img'>
                <img src={'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/' + url} alt="" />
            </div>
            {
                list.length > 0 && list.map((item, index) => {
                    return (
                        <div key={index}>
                            <div className='h5video-video-list' >
                                <video controls poster={`${'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/'}` + item.cover} >
                                    <source src={`${'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/'}` + item.video} type="video/mp4" />
                                </video>

                                {/* <video src={`${'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/'}` + item.video} poster={`${'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/'}` + item.cover} /> */}
                                <div className='h5video-video-liat-item'>{item.title}</div>
                            </div>
                        </div>
                    )
                })
            }
            <div className='h5video-bottom-img'>
                <img src={require('./images/bottom.png')} alt="" />
            </div>

        </section>
    );
};

export default PageModel;
